import SuperJSON from "superjson";
import Id from "../types/Id";

export default class RoleId extends Id<"role"> {}

SuperJSON.registerClass(RoleId);
